import dayjs from 'dayjs';

import { useIsWoopDemoMode } from 'features/workload-optimization';
import { useTimeRangeSelection } from 'hooks/useTimeRangeSelection';

import {
  RIGHTSIZING_DEFAULT_FILTER_PRESET,
  RIGHTSIZING_QUERY_PARAM_KEYS,
} from '../../../_hooks/useRightsizingTimeRangeSelection';

export const useWorkloadEventsTimeRangeSelection = () => {
  const isWoopDemoMode = useIsWoopDemoMode();

  const { initialState, preset, timeZone, from, to } = useTimeRangeSelection({
    queryParamKeys: RIGHTSIZING_QUERY_PARAM_KEYS,
    initialState: {
      preset: RIGHTSIZING_DEFAULT_FILTER_PRESET,
      timeZone: isWoopDemoMode ? 'UTC' : undefined,
    },
    allowTimeInput: true,
    constraints: {
      maxDate: () => dayjs.utc().toISOString(),
    },
  });

  const currentPreset = from && to ? undefined : preset || initialState.preset;

  return {
    from,
    to,
    timeZone,
    preset,
    initialState,
    currentPreset,
  };
};
